var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'card-badge': true,
    'card-badge--red': _vm.color === 'red',
    'card-badge--blue': _vm.color === 'blue',
    'card-badge--gray': _vm.color === 'gray',
  }},[_vm._t("default"),_c('p',{staticClass:"card-badge__text"},[_vm._v(_vm._s(_vm.text))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }